<script setup>
</script>

<template>
  <v-layout class="layout">
    <RouterView />
  </v-layout>
</template>

<style scoped>
</style>
